import { extendTheme } from "@chakra-ui/react"
import { cardTheme } from "style/Card"
import { headingTheme } from "style/Heading"
import { inputTheme } from "style/Input"
import { menuTheme } from "style/Menu.ts"
import { modalTheme } from "style/Modal"
import { popoverTheme } from "style/Popover"
import { tableTheme } from "style/Table"
import { textareaTheme } from "style/Textarea"

export default extendTheme({
  config: {
    initialColorMode: "dark", // 預設為暗黑模式
    useSystemColorMode: false, // 不跟隨系統模式
  },
  styles: {
    global: {
      "html, body": {
        bg: "linear-gradient(-45deg, #1b3961, #1A202C, #171923)",
        bgSize: "400% 400%",
      },
    },
  },
  components: {
    Modal: modalTheme,
    Table: tableTheme,
    Heading: headingTheme,
    Input: inputTheme,
    Textarea: textareaTheme,
    Popover: popoverTheme,
    Card: cardTheme,
    Menu: menuTheme,
  },
  fonts: {
    heading: `'Open Sans', 'Noto Sans TC', 'Noto Sans SC', 'PingFang TC', 'Microsoft JhengHei', 'Microsoft YaHei', sans-serif`,
    body: `'Raleway', 'Noto Sans TC', 'Noto Sans SC', 'PingFang TC', 'Microsoft JhengHei', 'Microsoft YaHei', sans-serif`,
  },
  initialColorMode: "system",
  useSystemColorMode: false,
})
